// @flow
/* eslint-disable no-unused-vars */
import * as wjcCore from 'wijmo/wijmo';

import { createColumnOrRowFormatter } from '../../../utils';
import type { FormatterArgs } from '../../../types';

const statusFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    columnName: 'Foc',
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    formatter: ({ elem, dataItem }) => {
      const item = dataItem;

      let color;

      switch (item.Foc) {
        case 'Y':
          color = 'green';
          break;
        default:
          color = '';
          break;
      }

      wjcCore.addClass(elem.cell, color);
    },
  });

export default statusFormatter;
